<template>
  <v-dialog persistent v-model="dialog" width="500" height="800">
    <v-card>
      <v-toolbar dark dense color="primary">
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form submit.prevent="submit">
          <v-text-field label="Title" v-model="item.title"> </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="submit" color="success">submit </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      item: {
        title: "",
      },
      title: "",
      callback: null,
    };
  },
  methods: {
    open(item, title, callback) {
      let self = this;
      self.item = item;
      self.title = title;
      self.callback = callback;
      self.dialog = true;
    },
    submit() {
      let self = this;
      self.dialog = false;
      self.callback(self.item);
    },
  },
};
</script>